export const companyDomains = [
    "rezonence.com",
    "yougov.com"
]
